<h3>{{ selectedConsumer?.name | titlecase }}</h3>
<h4 *ngIf="selectedConsumer && selectedLocation">{{ selectedLocation.name | titlecase }}</h4>
<aside>
    <button
        *ngIf="selectedConsumer"
        [attr.data-testid]="'add_button'"
        class="icon"
        mat-icon-button
        matTooltip="Add Submenu"
        (click)="add.emit()"
    >
        <mat-icon class="icon">add</mat-icon>
    </button>
</aside>
